(function () {
  'use strict';

  var HANDOFF_KEY = 'deckaura_reading_handoff';
  var HANDOFF_MAX_AGE = 15 * 60 * 1000;

  function publish(name, spread, extra) {
    var payload = Object.assign({
      event: name,
      event_schema: 'tarot_spreads_funnel_v2',
      spread: spread && spread.name ? spread.name : 'Unselected',
      spread_key: spread && spread.key ? spread.key : '',
      card_count: spread && spread.positions ? spread.positions.length : 0,
      page_path: window.location.pathname
    }, extra || {});
    try {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push(payload);
      if (typeof window.gtag === 'function') window.gtag('event', name, payload);
      document.dispatchEvent(new CustomEvent('deckaura:tarot-spread-event', { detail: payload }));
    } catch (_) {}
  }

  function spreadFromElement(details) {
    if (!details) return null;
    return {
      key: String(details.getAttribute('data-spread-key') || '').slice(0, 80),
      name: String(details.getAttribute('data-spread-name') || '').slice(0, 100),
      category: String(details.getAttribute('data-spread-category') || 'other').slice(0, 30),
      best: String(details.getAttribute('data-spread-best') || '').slice(0, 180),
      positions: Array.prototype.slice.call(details.querySelectorAll('[data-position-name]')).map(function (el, index) {
        return {
          n: index + 1,
          name: String(el.getAttribute('data-position-name') || ('Card ' + (index + 1))).slice(0, 80),
          desc: String(el.getAttribute('data-position-description') || '').slice(0, 180)
        };
      }).slice(0, 10)
    };
  }

  function handoffFor(spread) {
    return {
      v: 2,
      source: 'tarot-spreads',
      question: '',
      type: 'Tarot',
      context: 'The seeker chose the ' + spread.name + ' layout and its exact positions.',
      data: {
        label: 'Start my free ' + spread.name + ' spread',
        spread: spread.name,
        spreadKey: spread.key,
        category: spread.category,
        positions: spread.positions
      },
      createdAt: Date.now(),
      expiresAt: Date.now() + HANDOFF_MAX_AGE
    };
  }

  function writeHandoff(spread) {
    if (!spread || !spread.key || !spread.positions.length) return false;
    try {
      sessionStorage.setItem(HANDOFF_KEY, JSON.stringify(handoffFor(spread)));
      return true;
    } catch (_) { return false; }
  }

  function initSection(root) {
    if (!root || root.getAttribute('data-ts-ready') === 'true') return;
    root.setAttribute('data-ts-ready', 'true');
    var app = root.querySelector('.ts-app');
    var detailsList = Array.prototype.slice.call(root.querySelectorAll('.ts-spread'));
    var sticky = root.querySelector('[data-ts-sticky]');
    var stickyLink = sticky && sticky.querySelector('[data-ts-sticky-start]');
    var stickyLabel = sticky && sticky.querySelector('[data-ts-sticky-label]');
    var stickyMeta = sticky && sticky.querySelector('[data-ts-sticky-meta]');
    var selectedSpread = null;
    var freeReadingUrl = root.getAttribute('data-free-reading-url') || '/pages/free-tarot-reading';

    function updateSticky(spread) {
      selectedSpread = spread || selectedSpread;
      if (!stickyLink || !stickyLabel || !stickyMeta) return;
      if (selectedSpread) {
        stickyLabel.textContent = 'Start ' + selectedSpread.name + ' free';
        stickyMeta.textContent = selectedSpread.positions.length + (selectedSpread.positions.length === 1 ? ' card' : ' cards') + ' · exact positions preserved';
        stickyLink.href = freeReadingUrl + '#draw';
      } else {
        stickyLabel.textContent = 'Start a free tarot reading';
        stickyMeta.textContent = 'No signup · choose your cards';
        stickyLink.href = freeReadingUrl + '#ask';
      }
    }

    function updateDeepReading(spread) {
      var api = window.DeckauraDeepReading;
      if (!api || typeof api.enable !== 'function' || !spread) return;
      var positionNames = spread.positions.map(function (position) { return position.name; });
      try {
        api.enable({
          type: 'Tarot',
          context: 'The seeker wants a ' + spread.name + ' reading (' + spread.positions.length + ' positions: ' + positionNames.join(', ') + '). Best for: ' + spread.best + '.',
          question: '',
          tool: 'Tarot Spreads Guide',
          signals: [
            { label: 'Selected spread', value: spread.name },
            { label: 'Positions', value: String(spread.positions.length) },
            { label: 'Best for', value: spread.best }
          ],
          scope: 'Spread selection only; no cards have been drawn yet.',
          confidence: 'Symbolic tarot guidance for reflection, not a factual or guaranteed prediction.',
          resultReady: false,
          title: 'Draw Your ' + spread.name + ' Spread First',
          text: 'Your exact positions are ready. Continue to the free reader and choose all ' + spread.positions.length + ' cards before any interpretation.',
          action: 'bridge',
          bridgeUrl: freeReadingUrl + '#draw',
          bridgeData: handoffFor(spread).data,
          button: 'Start my free ' + spread.name + ' spread'
        });
      } catch (_) {}
    }

    detailsList.forEach(function (details) {
      var summary = details.querySelector('summary');
      var actionLabel = details.querySelector('[data-ts-action-label]');
      var closeButton = details.querySelector('[data-ts-close]');
      var startLinks = details.querySelectorAll('[data-ts-start]');

      function sync(openedByUser) {
        if (summary) summary.setAttribute('aria-expanded', details.open ? 'true' : 'false');
        if (actionLabel) actionLabel.textContent = details.open ? 'Hide positions' : 'Preview positions';
        if (!details.open) return;
        var spread = spreadFromElement(details);
        updateSticky(spread);
        updateDeepReading(spread);
        if (openedByUser) publish('spread_preview', spread, { interaction: 'details_opened' });
      }

      details.addEventListener('toggle', function () { sync(true); });
      sync(false);

      if (closeButton) closeButton.addEventListener('click', function () {
        details.open = false;
        if (summary) summary.focus({ preventScroll: true });
      });

      Array.prototype.forEach.call(startLinks, function (link) {
        link.addEventListener('click', function () {
          var spread = spreadFromElement(details);
          writeHandoff(spread);
          publish('spread_start', spread, { target: link.href, source: 'spread_detail' });
        });
      });
    });

    root.querySelectorAll('[data-ts-table-link]').forEach(function (link) {
      link.addEventListener('click', function (event) {
        var target = root.querySelector(link.getAttribute('href'));
        if (!target) return;
        event.preventDefault();
        target.open = true;
        updateSticky(spreadFromElement(target));
        window.setTimeout(function () {
          target.scrollIntoView({ behavior: 'smooth', block: 'start' });
          var summary = target.querySelector('summary');
          if (summary) summary.focus({ preventScroll: true });
        }, 30);
      });
    });

    root.querySelectorAll('[data-ts-general-start]').forEach(function (link) {
      link.addEventListener('click', function () {
        try { sessionStorage.removeItem(HANDOFF_KEY); } catch (_) {}
        publish('spread_start', null, { target: link.href, source: link.getAttribute('data-ts-source') || 'general_cta' });
      });
    });

    if (stickyLink) stickyLink.addEventListener('click', function () {
      if (selectedSpread) writeHandoff(selectedSpread);
      else { try { sessionStorage.removeItem(HANDOFF_KEY); } catch (_) {} }
      publish('spread_start', selectedSpread, { target: stickyLink.href, source: 'mobile_sticky' });
    });
    updateSticky(null);

    function stickyVisibility() {
      if (!sticky || window.innerWidth > 640) return;
      var hero = root.querySelector('.da-tool-hero');
      var footerBuffer = document.documentElement.scrollHeight - window.innerHeight - 220;
      var show = window.scrollY > (hero ? hero.offsetTop + hero.offsetHeight * 0.65 : 520) && window.scrollY < footerBuffer;
      sticky.classList.toggle('is-visible', show);
    }
    window.addEventListener('scroll', stickyVisibility, { passive: true });
    window.addEventListener('resize', stickyVisibility, { passive: true });
    stickyVisibility();

    var stars = root.querySelector('[data-ts-stars]');
    if (stars && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      var fragment = document.createDocumentFragment();
      for (var i = 0; i < 28; i += 1) {
        var star = document.createElement('span');
        star.style.left = (Math.random() * 100) + '%';
        star.style.top = (Math.random() * 100) + '%';
        var size = Math.random() * 2 + .5;
        star.style.width = size + 'px';
        star.style.height = size + 'px';
        star.style.setProperty('--dur', (Math.random() * 3 + 2) + 's');
        star.style.setProperty('--o', (Math.random() * .7 + .3).toString());
        fragment.appendChild(star);
      }
      stars.appendChild(fragment);
    }

    var currentHash = window.location.hash;
    if (/^#ts-spread-\d+$/.test(currentHash)) {
      var targeted = root.querySelector(currentHash);
      if (targeted) {
        targeted.open = true;
        updateSticky(spreadFromElement(targeted));
      }
    }

    var productForms = root.querySelectorAll('[data-ts-product-form]');
    Array.prototype.forEach.call(productForms, function (form) {
      form.addEventListener('submit', function () {
        publish('spread_deck_add_to_cart', selectedSpread, {
          product_handle: form.getAttribute('data-product-handle') || '',
          source: 'tarot_spreads_deck_card'
        });
      });
    });

    var leadForm = root.querySelector('[data-ts-lead-form]');
    if (leadForm) {
      var leadButton = leadForm.querySelector('button[type="submit"]');
      var leadStatus = leadForm.querySelector('[data-ts-lead-status]');
      var leadStartedAt = Date.now();
      var leadMessages = {
        invalid_email: 'Please enter a valid email address.',
        privacy_ack_required: 'Please accept the PDF delivery and privacy notice.',
        rate_limited: 'Too many requests were made from this connection. Please try again in one hour.',
        request_rejected: 'We could not verify this request. Refresh the page and try again.',
        download_unavailable: 'The download is temporarily unavailable. Please try again in a few minutes.'
      };
      function setLeadStatus(state, message) {
        leadStatus.setAttribute('data-state', state);
        leadStatus.textContent = message;
      }
      leadForm.addEventListener('submit', function (event) {
        event.preventDefault();
        if (!leadForm.reportValidity()) return;
        leadButton.disabled = true;
        leadButton.setAttribute('aria-busy', 'true');
        setLeadStatus('working', 'Preparing your secure download…');
        var values = new FormData(leadForm);
        var params = new URLSearchParams(window.location.search);
        publish('spread_lead_submitted', selectedSpread, { lead_magnet: 'tarot_cheat_sheet' });
        fetch(leadForm.getAttribute('data-endpoint'), {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            email: values.get('email'),
            website: values.get('website'),
            privacyAccepted: values.get('privacyAccepted') === 'on',
            marketingConsent: values.get('marketingConsent') === 'on',
            startedAt: leadStartedAt,
            locale: document.documentElement.lang || 'en',
            utmSource: params.get('utm_source'),
            utmMedium: params.get('utm_medium'),
            utmCampaign: params.get('utm_campaign')
          })
        }).then(function (response) {
          return response.json().catch(function () { return {}; }).then(function (data) {
            if (!response.ok) throw new Error(data.error || 'download_unavailable');
            return data;
          });
        }).then(function (data) {
          var downloadUrl = new URL(data.downloadUrl);
          if (downloadUrl.protocol !== 'https:' || !downloadUrl.hostname.endsWith('.supabase.co')) throw new Error('download_unavailable');
          setLeadStatus('success', 'Your download is ready. It should begin now.');
          publish('lead_magnet_download', selectedSpread, { lead_magnet: 'tarot_cheat_sheet' });
          window.setTimeout(function () { window.location.assign(downloadUrl.href); }, 250);
        }).catch(function (error) {
          var code = error && error.message ? error.message : 'download_unavailable';
          setLeadStatus('error', leadMessages[code] || leadMessages.download_unavailable);
          leadButton.disabled = false;
          leadButton.removeAttribute('aria-busy');
        });
      });
    }
  }

  function boot() {
    document.querySelectorAll('[data-section-type="tarot-spreads"]').forEach(initSection);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', boot);
}());
